import { Injectable, WritableSignal, signal } from '@angular/core';
import { Feature } from '@api/models';
import { PlacesForRequest } from '../models/placesForRequest.model';

@Injectable({
  providedIn: 'root'
})
export class SelectRoutePlacesService {

  public selectedFromOption:WritableSignal<Feature|null> = signal(null)
  public selectedToOption:WritableSignal<Feature|null> = signal(null)

  public getPlacesForRequest(): PlacesForRequest{
    return {
      fromPlace: this.selectedFromOption()?.geometry.coordinates,
      fromDescription: this.selectedFromOption()?.properties.name,
      toPlace: this.selectedToOption()?.geometry.coordinates,
      toDescription: this.selectedToOption()?.properties.name,
    }
  }

}
